import CircularProgress from '@mui/material/CircularProgress';
import colors from '../../assets/colors';

export default function DataLoading() {
  return (
    <h1 align={'center'}>
      <CircularProgress sx={{ color: colors.oldAgroweGreen }} size={80} />
    </h1>
  );
}
